import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

import { Button } from 'components/ui';
import { useState, useEffect }            from 'react';
import ReactGA  from "react-ga4";

const REST_API_KEY = process.env.REACT_APP_KAKAO_REST_API_KEY || "";
const REDIRECT_URI = process.env.REACT_APP_KAKAO_REDIRECT_URI_WEB || "";

const Elem:React.FC<any> = ({ showModal, closeModal }) =>{
  const gaId = process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID;

  const handleKakaoLogin = async () => {
    if (gaId){
        ReactGA.event({
          "category" : "Button",
          "action": "Click",
          "label" : "Kakao Login Button"
        })
      }

    const scope =`phone_number`
    const KAKAO_AUTH_URL = 
    `https://kauth.kakao.com/oauth/authorize?response_type=code&client_id=${REST_API_KEY}&redirect_uri=${REDIRECT_URI}&prompt=login&scope=${scope}&auth_type=reauthenticate`
    window.location.href = KAKAO_AUTH_URL;
  };

  useEffect (() => {
    if (gaId) {
      ReactGA.send({ hitType: "pageview", page:"/login", title: "login view" })
    }
  },[]);

  return (
    <>
      {showModal?
        <Background onClick={closeModal}  showModal={showModal}>
          <ModalContainer showModal={showModal}   onClick={e => e.stopPropagation()}>
            <CloseContainer
              onClick={closeModal}
            >
              X
            </CloseContainer>
            <ContentsConatiner>
              <TextContainer>
                <SmallText>신규 가입하고</SmallText>
                <SmallText className='Bold'>1회 무료 체험 후 구독 결정하세요</SmallText>
              </TextContainer>
              <LoginButtonWrapper>
              <LoginButton
                onClick={handleKakaoLogin}
              >
                <LoginImg>
                  <Img
                    src={"/images/kakaologin.png"}
                  />
                </LoginImg>
                <KakaoWrapper>
                  카카오로 3초만에 시작하기</KakaoWrapper>
              </LoginButton>
            </LoginButtonWrapper>
            </ContentsConatiner>
          </ModalContainer>
        </Background>:null }
    </>
  )
};

export default Elem;



const Background = styled.div<{ showModal:boolean }>`
  position:fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;

  z-index: 99;
  opacity: ${(props) => (props.showModal) ? 1: 0};
  visibility: ${(props) => (props.showModal ? 'visible' : 'hidden')};
  animation: ${(props) => props.showModal && slideIn} 1s ease-in-out;
`;

const slideIn = keyframes`
  from {
    transform: translateY(10%);
  }

  to {
    transform: translateY(0%);
  }
`;

const ModalContainer = styled.div<{ showModal:boolean }>`
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, 100%);
  max-height: 100%;
  width: 100%;
  height: 175px;
  background-color: white;
  text-align: center;
  display:flex;
  flex-direction: column;
  border-radius: 18px;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.25);
  animation: ${(props) => (props.showModal ? `${slideIn} 0.1s ease-in-out` : '')};
`;
const ContentsConatiner = styled.div`
  width: 90%;
  height: 110px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* background-color: aqua; */
  margin: -10px auto;
`
const SmallText = styled.div`
  font-family: 'Pretendard';
  font-style: normal;
  /* font-weight: light; */
  font-weight: 300;
  font-size: 14px;
  line-height: 133%;
  color: #000000;
  margin-top: 9px;

  &.Bold {
    font-weight: medium;
    /* font-size: 15px; */
    margin-top: 3px;
  }
`
const LoginButtonWrapper = styled.div`
  height: 45px;
  display: flex;
  flex-direction: row;
`;
const LoginImg = styled.div`
  width: 14px;
  height: 14px;
  margin-right: 10px;
`;
const Img= styled.img`
  width: 100%;
  height: 100%;
`;
const LoginButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 12px 0;
  border-radius: 4px;
  background-color: #f9e000;
  color: #000000;
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
`
const KakaoWrapper = styled.div`
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 15px;
  color: #3C1E1E;
`;
const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  /* margin-top: 16px; */
`;

const CloseContainer = styled.div`
  width: 20px;
  height: 20px;
  margin-top: 20px;
  margin-left: auto;
  margin-right: 20px;
  font-size: 16px;
`